'use client';

import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';

import { amplifyResourcesConfig } from '../config';
import { createClientStorage } from '../storages/client-storage';

export const configureAmplify = () => {
  Amplify.configure(amplifyResourcesConfig, {
    ssr: true,
  });

  cognitoUserPoolsTokenProvider.setKeyValueStorage(createClientStorage());
};
